import CityServicePage from "@/pages/city-service/CityServicePage";
import { torontoCommercial } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={torontoCommercial} />; }
